import {
  AddOneSlotToLoadingQueue,
  RemoveOneSlotToLoadingQueue,
} from "../../loading/loading.store";

import Service from "../../../../api/api-service";
import { ApiUrl } from "../../../../api/api-url";
import ShowNotification from "../../../../components/react-notifications/react-notifications";
import { NotificationMessageType } from "../../../../utils/configuration";

const service = new Service();

export const GET_BY_ID_REDIRECT_OK = "GET_BY_ID_REDIRECT_OK";
export const GET_BY_ID_REDIRECT_ERR = "GET_BY_ID_REDIRECT_ERR";

export function getByIdRedirectOk(payload) {
  return {
    type: GET_BY_ID_REDIRECT_OK,
    payload,
  };
}

export function getByIdRedirectErr(payload) {
  return {
    type: GET_BY_ID_REDIRECT_ERR,
    payload,
  };
}

export const getByIdRedirectService = {
  getByIdRedirect,
};

function getByIdRedirect(params) {
  return function (dispatch) {
    dispatch(AddOneSlotToLoadingQueue);
    return service
      .get(ApiUrl.CMSGetById + params)
      .then((response) => {
        dispatch(getByIdRedirectOk(response));
        dispatch(RemoveOneSlotToLoadingQueue);
      })
      .catch((error) => {
        dispatch(getByIdRedirectErr(error));
        dispatch(RemoveOneSlotToLoadingQueue);
        ShowNotification(error.errorMessage, NotificationMessageType.Error);
      });
  };
}
